import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BASE_URI, config } from '../../app.config';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';


@Injectable()
export class HeaderService {

    BASE_URL_STATIC = BASE_URI.URL;


    private _changeProfile = new Subject();
    profileIconChange$ = this._changeProfile.asObservable();

    private _changeCompanyLogo = new Subject();
    companyLogoChange$ = this._changeCompanyLogo.asObservable();

    constructor(private http: HttpClient) { }

    getCurrentUserDetail() {
        return this.http.get(`${this.BASE_URL_STATIC}/users/currentUser`);
    }

    getUserStatus() {
        return this.http.get(`${this.BASE_URL_STATIC}/status`);
    }

    userProfileChanged(profile) {
        this._changeProfile.next(profile);
    };

    instituteLogoChanged(institute){
      this._changeCompanyLogo.next(institute);
    }

    updateStatus(payload) {
        return this.http.post(`${this.BASE_URL_STATIC}/users/status`, payload);
    }

    getChannelList(){
      return this.http.get(`${this.BASE_URL_STATIC}/users/channelList`);
    }

    changeChannel(payLoad){
      // const params = this.preHttpParams(payLoad);
      return this.http.post(`${this.BASE_URL_STATIC}/users/changeChannel`, payLoad);
    }

    LLmLogout(url:string,llm_token:any){
    return this.http.post(url,{"token":llm_token});
  }
}
